<p class="heading">Rechnungstext</p>

@if (orderCustomReferenceText(); as text) {
  <p class="reference-text">{{ text }}</p>
}
